import React, { useState, useEffect } from "react";
import PressForm from "../../components/press/PressForm";
import { ChevronLeft, Loader2 } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { PressService } from "../../services/admin/PressService";
import { useNotification } from "../../context/NotificationContext";

export default function EditPressPage() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { showNotification } = useNotification();
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchItem = async () => {
            try {
                const data = await PressService.getPressById(id);
                // Map backend fields back to frontend form expectation
                setItem({
                    ...data,
                    date: data.date_display,
                    logo: data.logo_path
                });
            } catch (error) {
                showNotification({
                    type: "failed",
                    title: "Error",
                    message: "Failed to update press item."
                });
                navigate("/admin/press");
            } finally {
                setLoading(false);
            }
        };
        fetchItem();
    }, [id, navigate, showNotification]);

    const handleUpdate = async (data) => {
        try {
            const payload = {
                ...data,
                date_display: data.date,
                logo_path: data.logo
            };
            const response = await PressService.updatePress(id, payload);
            if (response.status === "success") {
                showNotification({ message: "Press coverage updated successfully", type: "success" });
                navigate("/admin/press");
            } else {
                showNotification({ message: response.message || "Failed to update press coverage", type: "error" });
            }
        } catch (error) {
            showNotification({ message: "An error occurred during update", type: "error" });
        }
    };

    return (
        <div className="p-6 lg:p-10 max-w-5xl mx-auto">
                <button
                    onClick={() => navigate("/admin/press")}
                    className="flex items-center gap-2 text-black dark:text-white/40 hover:text-black/70 dark:hover:text-white transition-colors text-xs font-bold tracking-widest uppercase mb-6"
                >
                    <ChevronLeft size={16} /> BACK TO PRESS
                </button>

                <div className="mb-10">
                    <h1 className="text-3xl lg:text-4xl font-normal text-black dark:text-white mb-2" style={{ fontFamily: "Playfair Display, serif" }}>
                        Edit Coverage
                    </h1>
                    <p className="text-black dark:text-white/50 text-sm italic font-serif">
                        Modify the details of this publication entry.
                    </p>
                </div>

                {loading ? (
                    <div className="flex flex-col items-center justify-center py-20">
                        <Loader2 size={40} className="text-jazz-brown animate-spin mb-4" />
                        <p className="text-black dark:text-white/50 text-xs font-bold tracking-widest uppercase">Loading details...</p>
                    </div>
                ) : (
                    <PressForm initialData={item} onSubmit={handleUpdate} isEditing={true} />
                )}
            </div>
    );
}
